import React from "react";
import styled from "styled-components";
import { Query, withApollo } from "react-apollo";
import gql from "graphql-tag";
import { RaisedButton } from "./../commons/";
import about from "./../../images/aboutus.jpg";
import { ProductsSection } from "./ProductsSection.jsx";
import { ProductCategories } from "./ProductCategories.jsx";
import HeroCarousel from "./HeroCarousel.jsx";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import FlatButton from "../commons/FlatButton";
import emblem from "../../images/emblem.png";
import ReactHtmlParser from 'react-html-parser';
import Testimonials from './Testimonials/Testimonials'
import IndexBlogs from "./EventBlogSection/IndexBlogs";
import IndexEvents from "./EventBlogSection/IndexEvents";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fcf8d1;

  @media (min-width: ${props => props.theme["mobileBreakpoint"]}) {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  & > .small {
    color: #000000;
    font-size: ${props => props.theme["$font-size-xxs"]};
    font-weight: ${props => props.theme["$weight-semi-bold"]};
    letter-spacing: 1.18px;
    text-transform: uppercase;
  }

  & > .big {
    font-family: ${props => props.theme['$font-secondary-medium']};
    font-size: 32px;

    @media (min-width: ${props => props.theme["mobileBreakpoint"]}) {
      font-size: ${props => props.theme["$font-size-lg"]};
    }
    font-weight: ${props => props.theme["$weight-semi-bold"]};
    letter-spacing: 1px;
    line-height: 57px;
  }
`;

const Todo = styled.div`
  text-align: center;
  font-size: 40px;
  display: block;
  width: 100%;
`;

const Body = styled.div`
  /* & > div {
    padding-left: 130px;
    padding-right: 130px;
  } */
`;

const About = styled.div`
  h1 {
    color: #000000;
    font-family: ${props => props.theme['$font-secondary-medium']};
    font-size: ${props => props.theme["$font-size-sm"]};
    @media (min-width: ${props => props.theme["mobileBreakpoint"]}) {
      font-size: ${props => props.theme["$font-size-lg"]};
    }
    font-weight: ${props => props.theme["$weight-regular"]};
    letter-spacing: 1px;
  }

  .pathmaking {

    display: flex;
    flex-direction: row;

    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h2 {
        color: #000000;
        font-family: ${props => props.theme['$font-secondary-medium']};
        font-size: 21px;
        font-weight: 600;
        letter-spacing: 0.5px;
        margin-bottom: 0px;
      }

      span {
        color: #000000;
        font-family: Lato;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 1.58px;
        text-transform: uppercase;
      }
    }
  }

  .emblem {
    max-height: 105px;
    max-width: 105px;
  }

  .body {
    font-size: ${props => props.theme["$font-size-xxs"]};
    font-weight: ${props => props.theme["$weight-regular"]};
    letter-spacing: 0.59px;
    line-height: 23px;
    color: #141d60;
  }

  a {
    color: inherit;
  }

  button {
    letter-spacing: 3px;
    a {
      color: white;
    }
  }
`;

const LIST_CATEGORIES = gql`
  query ListCategories($first: Int) {
    categories(first: $first) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const Home = props => (
  <div>
    <Body>
      {console.log(props.heroSliders)}
      <HeroCarousel heroSliders={props.heroSliders} />
      <IndexBlogs />
      <About className="full-width bg-gray py-5 px-5 px-lg-5">
        <Container className="mb-5">
          <Row>
            <Col xs="12" className="text-center mt-3 mb-5">
              <h1>{props.pageData && props.pageData.aboutSectionTitle && props.pageData.aboutSectionTitle}</h1>
            </Col>
            <Col lg="7" className="text-center">
              <img className="img-fluid" src={props.pageData && props.pageData.aboutSectionImage} />
              {props.pageData && !props.pageData.aboutSectionImage && ReactHtmlParser(props.pageData.aboutSectionVideoEmbed)}
            </Col>
            <Col lg="5" className="d-flex align-items-center">
              <div>
                <div className="row my-3">
                  <div className="col-12 pathmaking">
                    <img className="img-fluid emblem" src={emblem} alt="" />
                    <div className="text mx-3">
                      <h2>A Pathmaking Tradition</h2>
                      <span>SINCE 1946</span>
                    </div>
                  </div>
                </div>
                <p className="body my-2">
                  {props.pageData && props.pageData.aboutSectionText && ReactHtmlParser(props.pageData.aboutSectionText)} 
                </p>
                <RaisedButton className="btn-hover my-3">
                  <Link to="/aboutus">MORE ABOUT MARG</Link>
                </RaisedButton>
                <FlatButton><Link to="/history">HISTORICAL TIMELINE</Link></FlatButton>
                <FlatButton colorType="primary">
                  <Link to="/trustees">MARG TRUSTEES & ADVISORS</Link>
                </FlatButton>
              </div>
            </Col>
          </Row>
        </Container>
      </About>
      <IndexEvents />
      <Query query={LIST_CATEGORIES} variables={{ first: 10 }}>
        {({ loading, data, error }) => {
          if (loading || error) {
            return <div>Loading..</div>;
          }
          const categories = data.categories.edges;
          const categoryOb = categories.reduce(
            (acc, { node: { id, name } = {} }) => {
              if (name.toLowerCase().match(new RegExp(/magazine/gi))) {
                acc.magazineId = id;
              }
              if (name.toLowerCase().match(new RegExp(/book/gi))) {
                acc.bookId = id;
              }
              return acc;
            },
            {}
          );
          console.log("catID"  + categoryOb.magazineId);
          return (
            
            <div>
              <ProductsSection
                key={1}
                name="Magazine"
                categoryId={categoryOb.magazineId}
                slug="magazine"
              />
              <ProductsSection
                key={2}
                name="Books"
                categoryId={categoryOb.bookId}
                slug="books"
              />
            </div>
          );
        }}
      </Query>
      <ProductCategories />
      <Testimonials testimonials={props.testimonials} title={props.pageData && props.pageData.testimonialTitle}/>
    </Body>
  </div>
);
